import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class EchoService {

  private echo: Echo<'pusher'> | null = null;

  connect() {
    if (this.echo) {
      return this.echo;
    }

    (window as any).Pusher = Pusher;

    this.echo = new Echo({
      broadcaster: 'pusher',
      key: environment.pusher.key,
      cluster: environment.pusher.cluster,
      forceTLS: true,
      authEndpoint: environment.backend_server_url + '/broadcasting/auth',
      auth: {
        headers: {
          authToken: localStorage.getItem('authToken') || ''
        }
      }
    });

    return this.echo;
  }

  socketId(): string | null {
    return this.echo ? (this.echo.socketId() ?? null) : null;
  }

  privateChannel(name: string) {
    return this.connect().private(name);
  }

  leave(name: string) {
    if (this.echo) {
      this.echo.leave(name);
    }
  }

  disconnect() {
    if (this.echo) {
      this.echo.disconnect();
      this.echo = null;
    }
  }
}